module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "id": "user",
      "src": require("../assets/ICON_1.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isB
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isB
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/User.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": _vm.user,
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": _vm.check2,
      "blur": _vm.check2,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.down($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isC
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isC
    }
  }, [_c('img', {
    attrs: {
      "id": "img1",
      "src": require("../assets/Password.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "id": "psd",
      "type": "password",
      "placeholder": _vm.pas,
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      },
      "focus": _vm.check3,
      "blur": _vm.check3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'po1': _vm.isEs || _vm.isPo
    }
  }, [_c('div', {
    staticClass: "operate-left",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.choose
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('remember')))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-right"
  }, [_c('label', {
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v(_vm._s(_vm.$t('forget')))])])]), _vm._v(" "), _c('button', {
    staticClass: "login",
    class: {
      'po2': _vm.isEs || _vm.isPo
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('sign in')))]), _vm._v(" "), _c('button', {
    staticClass: "sign",
    on: {
      "click": _vm.sign
    }
  }, [_vm._v(_vm._s(_vm.$t('sign up now')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ffc3ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1418
// module chunks = 7